export const enum Mode {
  EDIT = 'EDIT',
  NEW = 'NEW',
}

export const enum Type {
  CLASSIC = 'CLASSIC',
  SMART = 'SMART',
}
